define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/config",
	"csi/def",
	"csi/def/AddPath",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, config, def, AddPath, Field, Relationship, Widget, reflection, xml, Query) {
	return declare(Widget, {

		FIELD_STYLE: "Style",
		FIELD_BOM_NAME: "BOMName",
		FIELD_BOM_SUBTYPE: "BOMSubtype",

		_resolveView: function() {
			var rc = reflection.getClass("ApparelBOM");
			var ra = reflection.getClassAttribute(rc, "Node Name");
			hasNodeNameExpr = ra.getExpression();

			if (!hasNodeNameExpr) {
				this.defView.addField(lang.mixin(new Field(), {
					m_label: this.FIELD_BOM_NAME,
					m_bRequired: true,
					m_type: xml.ATTR_STRING,
					m_typeControl: def.FIELD_TEXT,
					idParameter: this.FIELD_BOM_NAME
				}));
			}

			this.defView.addField(lang.mixin(new Field(), {
				m_label: this.FIELD_STYLE,
				m_typeControl: def.FIELD_MULTI_SELECT,
				idParameter: this.FIELD_STYLE,
				m_bRequired: true,
				widgetParams: {defaultAll: true},
				m_relationship: lang.mixin(new Relationship(), {
					m_typeNode: "Style",
					m_addPaths: [lang.mixin(new AddPath(), {
						m_path: "Parent:Theme"
					})],
					m_query: new Query()
						.Attr2("TDSMap", xml.OP_EQUALS, {
							Path: "Child:ProductType/Child:ProductionConfig",
							Index: "ApparelBOM",
							SValue: true
						})
						.Attr("Active", xml.OP_EQUALS, true)
				})
			}), !hasNodeNameExpr ? this.FIELD_BOM_NAME : null);

			if (config.hasSubtype("ApparelBOM")) {
				this.defView.addField(lang.mixin(new Field(), {
					m_label: this.FIELD_BOM_SUBTYPE,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_bRequired: true,
					bPersist: true,
					idParameter: this.FIELD_BOM_SUBTYPE,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: "ApparelBOMSubtype",
						m_query: new Query()
							.Attr("Active", xml.OP_EQUALS, true, "Child:Settings")
							.Attr("Published", xml.OP_EQUALS, true)
					})
				}), this.FIELD_STYLE);
			}

			this._setBOMType();

			this.inherited(arguments);

		},

		_setBOMType: function() {
			// summary: S10825 set a read-only value for BOM Type field from Theme BOM Type if exists
			// same function appears in MassUpdateThemeStylesForm.js
			var fd = this.defView.m_formData;
			var theme = fd.getParent();
			var themeBOMType = theme ? theme.ThemeBOMType : null;

			if (xml.isValidURL(themeBOMType)) {
				this.addFixedValue(this.FIELD_BOM_SUBTYPE, themeBOMType);
			}
		}
	});
});